import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useApi } from "@platform/api";

import { Carrier } from "../types/rfpApi";

interface UseRfpFinalDecisionCarriersOptions<TSelected> {
  rfpId: string;
  enabled?: boolean;
  select?: (data: Carrier[]) => TSelected;
}

export const getRfpFinalDecisionCarriersQueryKey = (
  rfpId: string,
): string[] => ["rfps", rfpId, "carriers", "final-decision"];

export function useRfpFinalDecisionCarriers<TSelected = Carrier[]>({
  rfpId,
  enabled = true,
  select,
}: UseRfpFinalDecisionCarriersOptions<TSelected>): UseQueryResult<
  TSelected,
  Error
> {
  const axios = useApi();
  return useQuery<Carrier[], Error, TSelected>({
    queryKey: getRfpFinalDecisionCarriersQueryKey(rfpId),
    enabled: enabled && !!rfpId,
    select,
    queryFn: () =>
      axios
        .get<Carrier[]>(`brokerportal/v1/rfp/${rfpId}/carriers/final-decision`)
        .then((res) => res.data),
  });
}
